export default __webpack_public_path__ + "static/media/electric-guitar (1).1c36a577.png";